export const CREATE_IMAGE = 'CREATE_IMAGE'
export const UPDATE_IMAGE = 'UPDATE_IMAGE'
export const DELETE_IMAGE = 'DELETE_IMAGE'

export const BANNER_TYPE = 'banner'
export const THUMBNAIL_TYPE = 'thumbnail'
export const IMAGE_TYPE = 'gallery'